import { CasPage } from 'src/compass/shared/components';
import CasRouterTabs from 'src/compass/shared/components/CasTabsView/CasRouterTabs';
import { AccountsTab, OwnersTab } from 'src/compass/application';
import { Terms } from 'src/compass/shared/util/terms';

import CustomersTab from './_customerMaintenance/components/CustomersTab';
import TagsTab from './_customerMaintenance/components/TagsTab';

// Each tab has its own URL, e.g. /utilities/Customers/Tags (routes built in UtilitiesMenu).
export const TabListCustomerMaintenance = {
  noDefault: false,
  tabs: [
    { label: Terms.Customer.plural, children: <CustomersTab /> },
    { label: 'Accounts', children: <AccountsTab /> },
    { label: 'Owners', children: <OwnersTab /> },
    { label: 'Tags', children: <TagsTab /> },
  ],
};

export default function CustomerMaintenancePage() {
  return (
    <CasPage title={`${Terms.Customer.label} Maintenance`} pageTitle="Utilities">
      <CasRouterTabs
        baseUrl={`/utilities/${Terms.Customer.plural}`}
        tabList={TabListCustomerMaintenance.tabs}
      />
    </CasPage>
  );
}
